export default "__VITE_ASSET__ghtDv10o__"